var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRightAngleArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 22 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M21.354 20.354a.5.5 0 0 0 0-.708l-3.182-3.181a.5.5 0 1 0-.707.707L20.293 20l-2.828 2.828a.5.5 0 1 0 .707.707l3.182-3.181ZM1 0H.5v12h1V0H1Zm8 20v.5h12v-1H9v.5Zm-8-8H.5A8.5 8.5 0 0 0 9 20.5v-1A7.5 7.5 0 0 1 1.5 12H1Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightAngleArrow);
export default __webpack_public_path__ + "static/media/right-angle-arrow.9090384748d67326806eabb442c9900a.svg";
export { ForwardRef as ReactComponent };